import React from 'react';
import PropTypes from 'prop-types';

import Link, { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import { LinkChevron } from '../../../02_molecules/Link';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBPartners = ({ title, seeAll = null, partners, behaviorSettings = null, uuid = null }) => {
  if (!(partners && partners.length)) {
    return null;
  }
  return (
    <div
      className={`bb bb-partners ${styles['bb-partners']} ${generateClassNameByBehaviorSettings(
        behaviorSettings,
      )}`}
      id={uuid}
    >
      <div className="container">
        <div className="wrapper">
          <div className="d-flex justify-content-between">
            {title && <h2>{title}</h2>}

            {seeAll && seeAll.label && seeAll.nextLink && (
              <div className="d-none d-md-block align-self-center link-container">
                <LinkChevron nextLink={seeAll.nextLink} label={seeAll.label} />
              </div>
            )}
          </div>

          <div className="d-flex flex-wrap justify-content-between partners">
            {partners.map((partner, index) => (
              <React.Fragment key={partner.title}>
                {/* centers the middle column on desktop */}
                <ul className={index % 3 === 1 ? 'ml-auto' : ''}>
                  <li className={partner.nextLink ? 'link-list' : 'fat-list'}>
                    <p>
                      {partner.nextLink && (
                        <Link {...partner.nextLink}>
                          <a target="_blank" rel="noopener noreferrer">
                            {partner.title}
                          </a>
                        </Link>
                      )}

                      {!partner.nextLink && partner.title}
                    </p>
                  </li>
                </ul>
              </React.Fragment>
            ))}
          </div>

          {seeAll && seeAll.label && seeAll.nextLink && (
            <div className="d-md-none text-center">
              <LinkChevron nextLink={seeAll.nextLink} label={seeAll.label} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

BBPartners.propTypes = {
  title: PropTypes.string.isRequired,
  seeAll: PropTypes.shape({
    label: PropTypes.string,
    nextLink: PropTypes.shape(linkPropTypes),
  }),
  partners: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      nextLink: PropTypes.shape(linkPropTypes),
    }),
  ).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBPartners;
